module.exports = __webpack_public_path__ + "img/portrait-074.26755f02.jpg";